<!-- eslint-disable vue/max-len -->
<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      :class="`svg-base color-stroke-${color}`"
      d="M16 20H8"
      stroke-width="2"
      stroke-miterlimit="10"
      stroke-linecap="square"
      stroke-linejoin="round"
    />
    <path
      :class="`svg-monitor color-fill-${color}`"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14 3H4C2.89543 3 2 3.89543 2 5V17C2 18.1046 2.89543 19 4 19H20C21.1046 19 22 18.1046 22 17V11H20V17H4V5H14V3Z"
    />
    <path
      :class="`svg-arrow-head color-stroke-${color}`"
      d="M17 4L21 4L21 8"
      stroke-width="2"
      stroke-miterlimit="10"
      stroke-linecap="square"
    />
    <path :class="`svg-arrow-tail color-stroke-${color}`" d="M20.5 4.5L14.5 11" stroke-width="2" />
  </svg>
</template>

<script setup lang="ts">
interface icon {
  color?: string;
}

withDefaults(defineProps<icon>(), {
  color: 'black',
});
</script>
